import React, {useContext} from 'react';
import MenuContext from "./MenuContext";
import { PermissionType } from 'types/PermissionType';

type Props = {
    page: any;
    children: React.ReactNode // Add the 'children' property to the 'Props' type
};

// This component is meant to be used everywhere a restriction based on user permission is needed
const MenuRestricted: React.FunctionComponent<Props> = ({page,  children}) => {

    // We "connect" to the provider thanks to the PermissionContext
    const {isAllowedTo} = useContext(MenuContext);

    // If the user has that permission, render the children
    if(isAllowedTo(page)){
        return <>{children}</>;
    }

    // Otherwise, do not render anything
    return null;
};

export default MenuRestricted;